import React from 'react';

const labelStyle = { display: 'block', fontSize: 12, color: '#a0a0b8', marginBottom: 8, textTransform: 'uppercase', letterSpacing: '0.05em' };

function SectionHeader({ title }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16, marginTop: 28 }}>
      <div style={{ width: 4, height: 16, background: 'linear-gradient(to bottom, #9F5CFF, #E34364)', borderRadius: 2 }} />
      <h3 style={{ margin: 0, fontSize: 16, color: '#fff', fontWeight: 700 }}>{title}</h3>
    </div>
  );
}

export default function BookingStep2({ form, update, errors, booths, backdrops = [], dbAddons = [], onNext, onBack }) {
  const validate = () => {
    const e = {};
    if (!form.booth_type) e.booth_type = 'Please select a booth type';
    if (!form.photo_strip_style) e.photo_strip_style = 'Please select a photo strip style';
    return e;
  };

  const handleAddonChange = (addon, quantity) => {
    const list = [...(form.selected_addons || [])];
    const idx = list.findIndex(item => item.id === addon.id);

    if (addon.type === 'boolean') {
      if (idx > -1) {
        list.splice(idx, 1);
      } else {
        list.push({ id: addon.id, quantity: 1 });
      }
    } else {
      const qty = parseInt(quantity) || 0;
      if (qty <= 0) {
        if (idx > -1) list.splice(idx, 1);
      } else {
        if (idx > -1) {
          list[idx].quantity = qty;
        } else {
          list.push({ id: addon.id, quantity: qty });
        }
      }
    }
    update({ selected_addons: list });
  };

  return (
    <div style={{ background: 'linear-gradient(135deg, #101428 0%, #0D0F20 100%)', borderRadius: 18, padding: 32, border: '1px solid rgba(227,67,100,0.3)' }}>
      <h2 style={{ margin: '0 0 4px', fontSize: 20, color: '#E34364', fontWeight: 700 }}>Booth & Add-ons</h2>
      <p style={{ margin: '0 0 28px', fontSize: 13, color: '#a0a0b8' }}>Choose your booth type and customize your experience</p>

      {/* Booth type */}
      <div style={{ marginBottom: 28 }}>
        <label style={labelStyle}>Booth Type <span style={{ color: '#E34364' }}>*</span></label>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: 12 }}>
          {booths.map((b) => {
            const selected = form.booth_type === b.title;
            return (
              <div key={b.id} onClick={() => update({ booth_type: b.title })}
                style={{ cursor: 'pointer', borderRadius: 12, overflow: 'hidden', border: `2px solid ${selected ? '#E34364' : 'rgba(255,255,255,0.08)'}`, transition: 'all 0.2s', transform: selected ? 'scale(1.03)' : 'scale(1)' }}>
                {b.image_url ? (
                  <img src={b.image_url} alt={b.title} style={{ width: '100%', height: 100, objectFit: 'cover', display: 'block' }} />
                ) : (
                  <div style={{ width: '100%', height: 100, background: 'rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontSize: 24 }}>{b.icon || '📸'}</span>
                  </div>
                )}
                <div style={{ padding: '8px 10px', background: selected ? 'rgba(227,67,100,0.15)' : 'rgba(255,255,255,0.03)', textAlign: 'center' }}>
                  <span style={{ fontSize: 13, fontWeight: 600, color: selected ? '#E34364' : '#e0e0e0' }}>{b.title}</span>
                </div>
              </div>
            );
          })}
        </div>
        {errors.booth_type && <p style={{ margin: '8px 0 0', fontSize: 12, color: '#E34364' }}>{errors.booth_type}</p>}
      </div>

      {/* Backdrop Selection */}
      <div style={{ marginBottom: 28 }}>
        <SectionHeader title="Select a Backdrop" />
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))', gap: 12 }}>
          {/* Card for No Backdrop */}
          <div onClick={() => update({ backdrop_id: null, backdrop_name: 'No Backdrop / TBD', backdrop_price: 0 })}
            style={{
              cursor: 'pointer', borderRadius: 12, overflow: 'hidden',
              border: `2px solid ${form.backdrop_id === null ? '#E34364' : 'rgba(255,255,255,0.08)'}`,
              transition: 'all 0.2s', background: form.backdrop_id === null ? 'rgba(227,67,100,0.08)' : 'rgba(255,255,255,0.02)',
              display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between'
            }}>
            <div style={{ height: 100, background: 'rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: 24 }}>🚫</span>
            </div>
            <div style={{ padding: '8px 10px', background: form.backdrop_id === null ? 'rgba(227,67,100,0.15)' : 'rgba(255,255,255,0.03)', textAlign: 'center', flexGrow: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <span style={{ fontSize: 12, fontWeight: 600, color: form.backdrop_id === null ? '#E34364' : '#e0e0e0' }}>No Backdrop / TBD</span>
            </div>
          </div>

          {backdrops.filter(b => b.active).map((b) => {
            const selected = form.backdrop_id === b.id;
            const price = parseFloat(b.price_addon) || 0;
            return (
              <div key={b.id} onClick={() => update({ backdrop_id: b.id, backdrop_name: b.name, backdrop_price: price })}
                style={{
                  cursor: 'pointer', borderRadius: 12, overflow: 'hidden',
                  border: `2px solid ${selected ? '#E34364' : 'rgba(255,255,255,0.08)'}`,
                  transition: 'all 0.2s', background: selected ? 'rgba(227,67,100,0.08)' : 'rgba(255,255,255,0.02)',
                  display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'space-between',
                  transform: selected ? 'scale(1.02)' : 'scale(1)'
                }}>
                {b.image_url ? (
                  <img src={b.image_url} alt={b.name} style={{ width: '100%', height: 100, objectFit: 'cover', display: 'block' }} />
                ) : (
                  <div style={{ width: '100%', height: 100, background: 'rgba(255,255,255,0.05)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <span style={{ fontSize: 24 }}>🎨</span>
                  </div>
                )}
                <div style={{ padding: '8px 10px', background: selected ? 'rgba(227,67,100,0.15)' : 'rgba(255,255,255,0.03)', textAlign: 'center', flexGrow: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                  <span style={{ fontSize: 12, fontWeight: 600, color: selected ? '#E34364' : '#e0e0e0', display: 'block' }}>{b.name}</span>
                  {price > 0 && <span style={{ fontSize: 11, color: '#27C85A', fontWeight: 700, marginTop: 2 }}>+${price.toFixed(2)}</span>}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Photo Strip Style */}
      <div style={{ marginBottom: 28 }}>
        <SectionHeader title="Photo Strip Style" />
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
          {['2×6 (Vertical)', '4×6 (Horizontal)'].map(style => {
            const sel = form.photo_strip_style === style;
            return (
              <div key={style} onClick={() => update({ photo_strip_style: style })}
                style={{ cursor: 'pointer', borderRadius: 10, border: `1px solid ${sel ? '#2762e8' : 'rgba(255,255,255,0.1)'}`, padding: '16px 12px', background: sel ? 'rgba(39,98,232,0.1)' : 'rgba(255,255,255,0.03)', display: 'flex', alignItems: 'center', gap: 10 }}>
                <div style={{ width: 16, height: 16, borderRadius: '50%', border: `2px solid ${sel ? '#2762e8' : '#555'}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  {sel && <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#2762e8' }} />}
                </div>
                <span style={{ fontSize: 14, color: sel ? '#2762e8' : '#e0e0e0', fontWeight: sel ? 700 : 400 }}>{style}</span>
              </div>
            );
          })}
        </div>
        {errors.photo_strip_style && <p style={{ margin: '8px 0 0', fontSize: 12, color: '#E34364' }}>{errors.photo_strip_style}</p>}
      </div>

      {/* Dynamic Add-ons */}
      <div>
        <SectionHeader title="Add-ons (Optional)" />
        <p style={{ margin: '-8px 0 16px', fontSize: 12, color: '#555', lineHeight: 1.5 }}>
          ⏱ Duration pricing is calculated automatically from your selected hours above.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {dbAddons.filter(a => a.active && a.type !== 'hourly').map(addon => {
            const matched = (form.selected_addons || []).find(item => item.id === addon.id);
            const selected = !!matched;
            const quantity = matched ? matched.quantity : 0;
            const price = parseFloat(addon.price) || 0;

            if (addon.type === 'boolean') {
              return (
                <div key={addon.id} onClick={() => handleAddonChange(addon)}
                  style={{ cursor: 'pointer', borderRadius: 12, border: `2px solid ${selected ? '#E34364' : 'rgba(255,255,255,0.08)'}`, padding: '14px 16px', background: selected ? 'rgba(227,67,100,0.08)' : 'rgba(255,255,255,0.02)', transition: 'all 0.2s', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                    <div style={{ width: 20, height: 20, borderRadius: 4, border: `2px solid ${selected ? '#E34364' : 'rgba(255,255,255,0.2)'}`, background: selected ? '#E34364' : 'transparent', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                      {selected && <span style={{ color: '#fff', fontSize: 12, fontWeight: 700 }}>✓</span>}
                    </div>
                    {addon.image_url && (
                      <img src={addon.image_url} alt={addon.name} style={{ width: 44, height: 44, borderRadius: 6, objectFit: 'cover', flexShrink: 0 }} />
                    )}
                    <div>
                      <span style={{ fontSize: 14, color: '#e0e0e0', fontWeight: selected ? 600 : 400, display: 'block' }}>{addon.name}</span>
                      {addon.description && <span style={{ fontSize: 11, color: '#a0a0b8', marginTop: 2, display: 'block' }}>{addon.description}</span>}
                    </div>
                  </div>
                  <span style={{ fontSize: 13, color: selected ? '#27C85A' : '#a0a0b8', fontWeight: 700 }}>
                    {price === 0 ? 'Included' : `+$${price.toFixed(2)}`}
                  </span>
                </div>
              );
            }

            // Hour-based or Quantity-based
            return (
              <div key={addon.id} style={{ borderRadius: 12, border: `1px solid ${selected ? '#E34364' : 'rgba(255,255,255,0.08)'}`, padding: '14px 16px', background: selected ? 'rgba(227,67,100,0.02)' : 'rgba(255,255,255,0.02)' }}>
                <div style={{ display: 'flex', gap: 12, alignItems: 'center', marginBottom: 12 }}>
                  {addon.image_url && (
                    <img src={addon.image_url} alt={addon.name} style={{ width: 44, height: 44, borderRadius: 6, objectFit: 'cover', flexShrink: 0 }} />
                  )}
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <span style={{ fontSize: 13, color: '#e0e0e0', fontWeight: 600 }}>{addon.name}</span>
                      <span style={{ fontSize: 13, color: '#a0a0b8', fontWeight: 600 }}>
                        ${price.toFixed(2)}{addon.type === 'hourly' ? '/hr' : '/unit'}
                      </span>
                    </div>
                    {addon.description && <span style={{ fontSize: 11, color: '#a0a0b8', marginTop: 2, display: 'block' }}>{addon.description}</span>}
                  </div>
                </div>
                
                <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                  <button onClick={() => handleAddonChange(addon, quantity - 1)}
                    style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', outline: 'none' }}>
                    −
                  </button>
                  <span style={{ fontSize: 18, fontWeight: 700, color: '#fff', minWidth: 40, textAlign: 'center' }}>
                    {quantity}
                  </span>
                  <button onClick={() => handleAddonChange(addon, quantity + 1)}
                    style={{ width: 36, height: 36, borderRadius: '50%', background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.1)', color: '#fff', fontSize: 18, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', outline: 'none' }}>
                    +
                  </button>
                  {quantity > 0 && (
                    <span style={{ fontSize: 13, color: '#27C85A', fontWeight: 600, marginLeft: 12 }}>
                      = +${(quantity * price).toFixed(2)}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ display: 'flex', gap: 12, marginTop: 32 }}>
        <button onClick={onBack} style={{ flex: 1, background: 'rgba(255,255,255,0.05)', color: '#fff', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 50, padding: '14px 0', fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
          ← Back
        </button>
        <button onClick={() => onNext(validate())} style={{ flex: 2, background: '#E34364', color: '#fff', border: 'none', borderRadius: 50, padding: '14px 0', fontSize: 14, fontWeight: 700, cursor: 'pointer' }}>
          Next: Review & Price →
        </button>
      </div>
    </div>
  );
}
